import React, { useState, useEffect, useCallback } from 'react';
import { getOrdiniDaNotificareConsegna, inviaNotificheConsegnaBulk } from '../services/api';
import { Table, Form, Spinner, Alert, Row, Col, Card, Button, Badge, Modal } from 'react-bootstrap';

function OrdiniNotificheConsegna() {
  const [ordini, setOrdini] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [invio, setInvio] = useState(false);

  const fetchOrdini = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getOrdiniDaNotificareConsegna();
      setOrdini(response.data);
      setSelectedIds([]);
    } catch (err) {
      setError('Errore nel caricamento degli ordini da notificare.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOrdini();
  }, [fetchOrdini]);

  const toggleSelect = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const toggleSelectAll = () => {
    setSelectedIds(prev => prev.length === ordini.length ? [] : ordini.map(o => o.id));
  };

  const ordiniSelezionati = ordini.filter(o => selectedIds.includes(o.id));

  const handleConfirmInvio = async () => {
    setInvio(true);
    try {
      const response = await inviaNotificheConsegnaBulk(selectedIds);
      const { inviati, errori } = response.data;
      let messaggio = `${inviati.length} notifiche inviate con successo.`;
      if (errori.length > 0) {
        messaggio += `\n\n${errori.length} errori:\n` + errori.map(e => `Ordine ${e.ordine_id}: ${e.errore}`).join('\n');
      }
      alert(messaggio);
      setShowPreview(false);
      fetchOrdini();
    } catch (err) {
      alert(`Errore durante l'invio: ${err.response?.data?.detail || err.message}`);
    } finally {
      setInvio(false);
    }
  };

  return (
    <>
      <Row className="mb-4 align-items-center">
        <Col>
          <h1 className="h3">Notifiche consegna IBS/Feltrinelli</h1>
          <Badge bg="secondary">{ordini.length} ordini in attesa</Badge>
        </Col>
      </Row>
      <Alert variant="info">
        Richiesta di conferma ricezione per ordini consegnati (risultano tali da almeno un giorno, per
        sicurezza contro falsi positivi del tracciamento). L'invio resta manuale: rivedi l'elenco e conferma.
      </Alert>
      <Card>
        <Card.Header>
          <Button
            variant="primary"
            disabled={selectedIds.length === 0}
            onClick={() => setShowPreview(true)}
          >
            Invia notifica selezionati ({selectedIds.length})
          </Button>
        </Card.Header>
        <Card.Body>
          {loading && <div className="text-center"><Spinner animation="border" /></div>}
          {error && <Alert variant="danger">{error}</Alert>}
          {!loading && !error && ordini.length === 0 && (
            <p className="text-muted mb-0">Nessun ordine da notificare al momento.</p>
          )}
          {!loading && !error && ordini.length > 0 && (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>
                    <Form.Check
                      type="checkbox"
                      checked={selectedIds.length === ordini.length}
                      onChange={toggleSelectAll}
                    />
                  </th>
                  <th>ID Ordine</th>
                  <th>Cliente</th>
                  <th>Origine</th>
                  <th>N. Ordine Marketplace</th>
                  <th>Data Consegna</th>
                </tr>
              </thead>
              <tbody>
                {ordini.map(o => (
                  <tr key={o.id} onClick={() => toggleSelect(o.id)} style={{ cursor: 'pointer' }}>
                    <td onClick={(e) => e.stopPropagation()}>
                      <Form.Check
                        type="checkbox"
                        checked={selectedIds.includes(o.id)}
                        onChange={() => toggleSelect(o.id)}
                      />
                    </td>
                    <td>{o.id}</td>
                    <td>{o.cliente_nome || 'N/A'}</td>
                    <td><Badge bg="secondary">{o.origine}</Badge></td>
                    <td>{o.numero_ordine_marketplace}</td>
                    <td>{o.data_consegna ? new Date(o.data_consegna).toLocaleDateString('it-IT') : 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      <Modal show={showPreview} onHide={() => setShowPreview(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Conferma invio ({ordiniSelezionati.length} ordini)</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {ordiniSelezionati.map(o => (
            <Card className="mb-3" key={o.id}>
              <Card.Header>
                Ordine #{o.id} — {o.cliente_nome || 'N/A'} ({o.numero_ordine_marketplace})
              </Card.Header>
              <Card.Body>
                <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', margin: 0 }}>
                  {o.messaggio_anteprima}
                </pre>
              </Card.Body>
            </Card>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPreview(false)} disabled={invio}>
            Annulla
          </Button>
          <Button variant="primary" onClick={handleConfirmInvio} disabled={invio}>
            {invio ? <><Spinner as="span" animation="border" size="sm" /> Invio...</> : 'Conferma e invia'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default OrdiniNotificheConsegna;
